import {DayOfWeek} from './types';

export const UI_SELECTED_DAYS_FREQUENCY = 'selected-days';

export const DAILY_CADENCE_DAYS: DayOfWeek[] = [
  'Sun',
  'Mon',
  'Tue',
  'Wed',
  'Thu',
  'Fri',
  'Sat',
];

export const includesEveryCadenceDay = (days: DayOfWeek[] = []) =>
  DAILY_CADENCE_DAYS.every((day) => days.includes(day));

export const resolveDailyUiFrequency = (
  frequency: string,
  selectedDays: DayOfWeek[],
) =>
  frequency === 'daily' &&
  selectedDays.length > 0 &&
  !includesEveryCadenceDay(selectedDays)
    ? UI_SELECTED_DAYS_FREQUENCY
    : frequency;
